import { FilterButton } from 'libs/searchspring/components/collection/filters/FilterButton'
import { useFilters } from 'libs/searchspring/hooks/useFilters'
import { FilterToggleButton, SortToggleButton } from '@/components/custom-elements/searchspring-buttons'
import { ImageViewToggleButton } from '@/components/custom-elements/image-view-toggle-button'

export const CollectionToolbar = () => {
  const { handleOpenFilters, handleToggleFilter, fetchedFilters, activeFilters, handleClearFilters } = useFilters()

  const handleFilterDrawerOpen = (filterId) => {
    document.querySelectorAll('x-modal[data-id^="filter-"]').forEach((modal) => {
      modal.removeAttribute('data-ui')
    })
    handleOpenFilters()
    const drawer = document.querySelector('x-modal[data-id="filters"]')
    drawer?.handleToggle()
    if (filterId) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const scrollAfterAccordion = () => {
            const target = document.querySelector(`x-modal[data-id="filters"] x-modal[data-id="${filterId}"]`)
            target?.scrollIntoView({ block: 'start', behavior: 'smooth' })
          }
          setTimeout(scrollAfterAccordion, 350)
        })
      })
    }
  }

  return (
    <div className="collection-toolbar z-40 grid min-h-[44px] w-full grid-cols-2 items-center justify-between border-b border-neutral-medium bg-secondary lg:flex lg:min-h-[54px] lg:gap-x-margin lg:px-margin lg:py-0.375 lg-max:sticky lg-max:top-header-adapt">
      <div className="overflow-hidden flex h-full items-stretch lg:-ml-margin lg:grow lg-max:w-full lg-max:justify-center lg-max:border-r lg-max:border-neutral-medium">
        <div className="hidden size-full items-stretch lg:flex">
          <div className="overflow-hidden relative h-full border-r border-neutral-medium">
            <div className="flex h-full items-stretch overflow-x-scroll whitespace-nowrap no-scrollbar after:pointer-events-none after:absolute after:z-2 after:h-full after:w-[36px] after:bg-white-to-transparent-left after:content-[''] after:inset-tr">
              <SortToggleButton className="flex h-auto border-r border-neutral-medium px-1 link-fade first:pl-margin last:border-r-0" />
              {fetchedFilters.map((filter) => (
                <FilterButton
                  filter={filter}
                  activeFilters={activeFilters}
                  onFilter={handleToggleFilter}
                  fetchedFilters={fetchedFilters}
                  onClick={handleFilterDrawerOpen}
                  key={filter.field}
                />
              ))}
            </div>
          </div>
          {activeFilters.size > 0 && (
            <button
              className="paragraph-s text-line text-line-space flex h-auto shrink-0 items-center justify-center px-1.5 font-medium text-neutral-secondary link-fade"
              onClick={handleClearFilters}
              aria-label="Clear All Filters"
              type="button"
            >
              Clear All
            </button>
          )}
        </div>
        <div className="flex w-full lg:hidden">
          <FilterToggleButton
            className="font-heading paragraph-s flex w-full items-center justify-center gap-x-0.625 font-medium uppercase !leading-none link-fade"
            iconClass="w-[15px] h-[10px]"
          />
        </div>
      </div>

      <div className="flex items-center justify-center lg:shrink-0 lg-max:w-full">
        <ImageViewToggleButton className="font-heading paragraph-s flex w-full items-center justify-center gap-x-0.625 font-medium uppercase !leading-none link-fade" />
      </div>
    </div>
  )
}
